import { render, staticRenderFns } from "./ANZBUTTON.vue?vue&type=template&id=b167b3fa"
import script from "./ANZBUTTON.vue?vue&type=script&lang=js"
export * from "./ANZBUTTON.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports